<template>
  <div id="div-main">
    <b-table
      striped
      hover
      class="mt-3"
      :items="shippingServices"
      :fields="fields"
      small
      ><!-- table -->
      <template v-slot:cell(name)="row">
        <a @click="editShippingService(row.item)" class="link2">{{
          row.item.name
        }}</a>
      </template>
      <template v-slot:cell(isActive)="row">
        <b-button
          size="sm"
          :variant="row.item.isActive ? 'primary' : 'secondary'"
          @click="activateShippingService(row.item)"
          ><!-- button -->
          <span v-if="row.item.isActive" class="icon icon-checkmark"></span>
          <span v-else class="icon icon-cross"></span>
        </b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalWarningState"
      id="modal-warning-dialog"
      title="Vorgang Abbrechen"
      size="sm"
      centered
      no-close-on-backdrop
      no-close-on-esc
      ><!-- modal -->
      <p>
        Sind Sie sicher, dass Sie den Versanddienstleister ohne zu speichern
        schliessen wollen?
      </p>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-button
              centered
              size="md"
              class="float-right mr-1 ml-2"
              variant="danger"
              @click="
                () => {
                  this.editModal.reset();
                  this.modalWarningState = false;
                }
              "
              >wirklich schliessen</b-button
            >
            <b-button
              centered
              size="md"
              class="float-right mx-1"
              variant="primary"
              @click="modalWarningState = false"
              >weiter editieren</b-button
            >
          </b-row>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalInvalidDataState"
      id="modal-warning-dialog"
      title="Ungültige Daten"
      size="md"
      centered
      no-close-on-backdrop
      no-close-on-esc
      ok-title="ok"
      cancel-disabled
      cancel-title="abbrechen"
      ><!-- modal -->
      <p>
        Versanddienstleister kann nicht abgespeichert werden. Jeder
        hinzugefügter Eintrag muss sowohl <b>URL</b> und
        <b>Carrier Code</b> haben.
      </p>
    </b-modal>

    <div v-if="editModal.shippingService">
      <b-modal
        centered
        :title="editModal.shippingService.name"
        v-model="editModal.visible"
        size="xl"
        hide-header-close
        body-class="pt-1"
        ><!-- modal -->
        <!-- span style="link2" v-if="editModal.shippingService">{{editModal.shippingService.name}}</span -->
        <b-overlay
          id="overlay-edit-modal"
          :show="editModal.queryInProgress"
          variant="light"
          opacity="0.5"
          blur="2px"
          rounded="lg"
          ><!-- overlay -->
          <span>URL Defaultwert: </span><b>»</b
          >{{ editModal.shippingService.url }}<b>«</b>
          <div class="row" id="edit-modal-stuff">
            <div class="col-md-12">
              <div class="d-flex flex-row justify-content-end">
                <div class="d-flex flex-row-reverse">
                  <div class="pl-2 py-2">
                    <b-button
                      size="md"
                      @click="editModal.addMarketAccountShippingService()"
                      ><span class="icon icon-plus"
                    /></b-button>
                  </div>
                  <div class="py-2">
                    <b-form-select
                      id="edit-modal-market-account-select"
                      v-model="editModal.selectedMarketAccountId"
                      :options="editModal.remainingMarketAccounts"
                      size="md"
                    ></b-form-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-table
            v-if="editModal.shippingService"
            id="table-edit-shipping-service"
            :items="editModal.shippingService.market_account_shipping_services"
            :fields="editModal.fields"
            :tbody-tr-class="editModal.rowClass"
            small
            ><!-- table -->

            <template v-slot:cell(carrierCode)="row">
              <b-input v-model="row.item.carrierCode" />
            </template>

            <template v-slot:cell(carrierName)="row">
              <b-input v-model="row.item.carrierName" />
            </template>

            <template v-slot:cell(carrierProduct)="row">
              <b-input v-model="row.item.carrierProduct" />
            </template>

            <template v-slot:cell(url)="row">
              <b-input v-model="row.item.url" />
            </template>

            <template v-slot:cell(marketAccountId)="row">
              <span>{{
                marketAccounts.find(
                  (marketAccount) =>
                    marketAccount.id === row.item.marketAccountId,
                ).name
              }}</span>
            </template>

            <template v-slot:cell(action)="row">
              <b-button
                @click="editModal.removeMarketAccountShippingService(row.item)"
                ><span class="icon icon-bin"
              /></b-button>
            </template>
          </b-table>
        </b-overlay>
        <template #modal-footer>
          <div class="w-100">
            <b-button
              class="float-right mx-1"
              centered
              size="md"
              variant="primary"
              @click="editModal.saveMarketAccountShippingService()"
              :disabled="editModal.queryInProgress"
              >speichern</b-button
            >
            <b-button
              class="float-right"
              size="md"
              variant="secondary"
              @click="modalWarningState = true"
              :disabled="editModal.queryInProgress"
              >abbrechen</b-button
            >
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<style scoped>
.link2 {
  color: #131313 !important;
}
.link2:hover {
  color: #25bf43 !important;
  cursor: pointer;
}
</style>
<script>
export default {
  data() {
    return {
      modalWarningState: false,
      modalInvalidDataState: false,
      marketAccounts: null,
      editModal: {
        self: this,
        visible: false,
        queryInProgress: false,
        shippingService: null,
        remainingMarketAccounts: null,
        selectedMarketAccountId: null, // the marketAccount which is currently selected in the dropdown menu of remaining marketAccounts.
        reset() {
          this.queryInProgress = false;
          this.shippingService = null;
          this.remainingMarketAccounts = null;
          this.selectedMarketAccountId = null;
          this.visible = false;
        },
        addMarketAccountShippingService() {
          //const marketAccount = this.self.marketAccounts.find( other => other.id == this.selectedMarketAccountId);
          // we don't need to worry about duplicate ids because marketAccounts are filtered out that are already in the list.
          this.shippingService.market_account_shipping_services.push({
            id: null,
            carrierCode: null,
            marketAccountId: this.selectedMarketAccountId,
            shippingServiceId: this.shippingService.id,
          });
          this.filterRemainingMarketAccounts();
          // save on modal close later
        },
        filterRemainingMarketAccounts() {
          this.remainingMarketAccounts = this.self.marketAccounts
            .filter((marketAccount) => {
              for (const elem of this.shippingService
                .market_account_shipping_services)
                if (elem.marketAccountId === marketAccount.id) return false;
              return true;
              // no idea why this code isn't working. Maybe it has to do something with
              // return !this.editModal.shippingService.market_account_shipping_services.includes( mass => {
              //     return mass.marketAccountId === marketAccount.id
              // });
            })
            .map((marketAccount) => {
              return { text: marketAccount.name, value: marketAccount.id };
            });
        },
        saveMarketAccountShippingService() {
          for (const mass of this.shippingService
            .market_account_shipping_services) {
            if (!mass.carrierCode || mass.carrierCode == "") {
              this.self.modalInvalidDataState = true;
              return;
            }
          }
          this.queryInProgress = true;
          Promise.all([
            axios.post("/shipping_service/save", {
              payload: JSON.stringify(this.shippingService),
            }),
            new Promise((r) => setTimeout(r, 333)),
          ])
            .then(([response]) => {
              this.shippingService = _.cloneDeep(response.data);
              this.shippingService.isActive = [1, "1", true, "true"].includes(
                this.shippingService.isActive,
              );
              // yes, this is necessary (this.shippingService is byValue and doesn't ref this.self.shippingServices[...]).
              for (
                let index = 0;
                index < this.self.shippingServices.length;
                ++index
              ) {
                if (
                  this.self.shippingServices[index].id ==
                  this.shippingService.id
                ) {
                  this.self.shippingServices[index] = response.data;
                  this.self.shippingServices[index].isActive = [
                    1,
                    "1",
                    true,
                    "true",
                  ].includes(this.self.shippingServices[index].isActive);
                  // these shenanigans are necessary, if not, b-table's :shippingServices stays un-mutated,
                  // which means, if you edit a shippingService, then save and re-open the same shippingService,
                  // it will be the old shippingService, eventhough the data (this.self.shippingServices) has changed.
                  // this is definitely a bug in Vue. Reactivity is triggered, however, if the whole array is replaced.
                  const dump = _.cloneDeep(this.self.shippingServices);
                  this.self.shippingServices = _.cloneDeep(dump);
                  break;
                }
              }
              this.reset();
              this.self.$bvToast.toast("Aktion erfolgreich ausgefuehrt.", {
                title: "Shipping Service",
                noAutoHide: false,
                autoHideDelay: 1250,
                appendToast: false,
                variant: "success",
              });
              this.self.$forceUpdate();
            })
            .catch((error) => {
              this.queryInProgress = false;
              console.error(error);
              this.self.$bvToast.toast(
                "Versanddienstleister nicht abgespeichert.",
                {
                  title: "Fehler",
                  noAutoHide: false,
                  autoHideDelay: 92500,
                  appendToast: false,
                  variant: "danger",
                },
              );
            });
        },
        removeMarketAccountShippingService(mass) {
          if (!mass.id) {
            // wtf am I doing?
            //let dump = this.self.marketAccounts.indexOf( this.self.marketAccounts.find( marketAccount => marketAccount.id == mass.id ) );
            // const marketAccountIndex = ( function(marketAccounts, marketAccountId) {
            //    marketAccounts.forEach( (marketAccount, index) => {
            //       if(marketAccountId === marketAccount.id) return index;
            //    });
            //    return -1;
            // })(this.self.marketAccounts, mass.marketAccountId);
            //this.self.marketAccounts.splice( marketAccountIndex, 1 );
            this.shippingService.market_account_shipping_services =
              this.shippingService.market_account_shipping_services.filter(
                (other) => other.marketAccountId !== mass.marketAccountId,
              );
            return;
          }
          this.queryInProgress = true;
          Promise.all([
            axios.delete(`shipping_service/delete/${mass.id}`),
            new Promise((r) => setTimeout(r, 333)),
          ])
            .then(() => {
              this.shippingService.market_account_shipping_services =
                this.shippingService.market_account_shipping_services.filter(
                  (other) => other.marketAccountId !== mass.marketAccountId,
                );
              this.queryInProgress = false;
              this.self.$bvToast.toast("Aktion erfolgreich ausgefuehrt.", {
                title: "Shipping Service",
                noAutoHide: false,
                autoHideDelay: 1250,
                appendToast: false,
                variant: "success",
              });
            })
            .catch((error) => {
              alert(
                "Shipping Service konnte nicht geloescht werden. Bitte den Devs melden.",
              );
              console.error(error);
              this.queryInProgress = false;
            });
        },
        fields: [
          { key: "carrierCode", label: "Carrier Code", sortable: true },
          { key: "carrierName", label: "Carrier Name", sortable: true },
          { key: "carrierProduct", label: "Carrier Product", sortable: true },
          { key: "url", label: "URL", sortable: true },
          { key: "marketAccountId", label: "Market Account", sortable: true },
          { key: "action", label: "", sortable: false },
        ],
        rowClass(shippingService, type) {
          if (!shippingService || type !== "row") return;

          if (
            !shippingService.carrierCode ||
            shippingService.carrierCode == ""
          ) {
            return "table-warning";
          }
          if (!shippingService.id) return "table-success";
        },
      },
      shippingServices: [],
      fields: [
        { key: "id", label: "#", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "isActive", label: "Aktiv", sortable: true },
      ],
    };
  },
  methods: {
    editShippingService(shippingService) {
      // for some reason the b-table is copying shippingServices byValue instead
      // of by ref. this means shippingService here will stay the same,
      // also if this.shippingServices mutates. I have no idea why this is the case
      this.editModal.shippingService = _.cloneDeep(shippingService);
      this.editModal.filterRemainingMarketAccounts();
      this.editModal.visible = true;
    },
    activateShippingService(shippingService) {
      shippingService.isActive = !shippingService.isActive;
      axios
        .get(`/shipping_service/flip/${shippingService.id}`)
        .then(() => {
          for (let k = 0; k < this.shippingServices.length; ++k) {
            if (this.shippingServices[k].id == shippingService.id) {
              this.shippingServices[k].isActive = shippingService.isActive;
              break;
            }
          }

          this.$bvToast.toast("Aktion erfolgreich ausgefuehrt.", {
            title: "Shipping Service",
            noAutoHide: false,
            autoHideDelay: 1250,
            appendToast: false,
            variant: "success",
          });
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Etwas ist schief gegangen.", {
            title: "Shipping Service",
            noAutoHide: true,
            appendToast: false,
            variant: "danger",
          });
        });
    },
  },
  created() {
    axios.get("/shipping_service/all").then((response) => {
      this.shippingServices = response.data.map((shippingService) => {
        shippingService.isActive = shippingService.isActive ? true : false; //ass
        return shippingService;
      });
    });

    axios.get("/marketaccount/all").then((response) => {
      this.marketAccounts = response.data;
    });
  },
};
</script>
